<template>
  <CShelf align="top">
    <CIcon name="person" class="u-mt-2"/>
    <div>
      <p class="u-semibold u-title">
        {{ $t('contactSelector.contactTitle', { name: contact.customer.fullName, type: getCustomerTypeLabel(contact.customer.type) }) }}
      </p>

      <p v-if="targets">
        {{ targets }}
      </p>

      <template v-if="!simple">
        <p v-if="collapsed && nonDrivers" class="u-medium">
          {{ nonDrivers }}
        </p>

        <template v-if="!collapsed && !contact.isLeasing && context">
          <CButton theme="link" @click.stop="ContactModals.contact(context, contact)" class="u-p-0">
            <CIcon name="compose-pen" :size="20"/>
            {{ $t('general.edit') }}
          </CButton>
        </template>
      </template>
    </div>
  </CShelf>
</template>

<script setup lang="ts">
  import { computed } from 'vue';
  import CIcon from '@/shared/components/CIcon.vue';
  import CShelf from '@/shared/components/CShelf.vue';
  import CButton from '@/shared/components/buttons/CButton.vue';
  import { getCustomerTypeLabel } from '@/shared/utils/labels';
  import CustomerType from '../constants/CustomerType';
  import ContactContext from '../models/ContactContext';
  import DossierContact from '../models/DossierContact';
  import ContactModals from '../util/ContactModals';

  const props = defineProps<{
    contact: DossierContact;
    context?: ContactContext;
    collapsed?: boolean;
    simple?: boolean;
  }>();

  const targets = computed(() => {
    return props.contact.customer?.communicationSummary ?? [props.contact.customer?.emails, props.contact.customer?.mobilePhones].flat().join(', ');
  });

  const nonDrivers = computed(() => {
    return props.context.contacts.filter(c => c.customer.type !== CustomerType.DRIVER).map(c => c.customer?.fullName).join(', ');
  });
</script>